<template>
  <div class="center_box">
    <div class="content_box">
      <div class="title_transportation">
        <div
          class="title_transportation_box"
          v-for="(item, index) in warehouseList"
          :key="index"
          @click="clickHouse(item.id)"
        >
          <el-badge
            :value="item.ordernumber"
            v-if="item.ordernumber > 0"
            class="item"
          >
            <img
              :class="
                house == item.id
                  ? 'transportation_img box_shadow'
                  : 'transportation_img'
              "
              v-if="item.photo"
              :src="item.photo"
              alt=""
            />
            <img
              :class="
                house == item.id
                  ? 'transportation_img box_shadow'
                  : 'transportation_img'
              "
              v-else
              src="@/assets/img/house.png"
              alt=""
            />
          </el-badge>
          <img
            :class="
              house == item.id
                ? 'transportation_img box_shadow'
                : 'transportation_img'
            "
            v-if="item.photo && item.ordernumber == 0"
            :src="item.photo"
            alt=""
          />

          <div
            :class="
              house == item.id
                ? 'color2 transportation_text'
                : 'transportation_text'
            "
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>

    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">筛选查询</div>
      </div>
      <!-- 搜索筛选 -->
      <div>
        <div class="table_item_box">
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">运单号</div>

              <input
                v-model="screen.ordernumber"
                type="text"
                placeholder="请输入运单号"
                class="table_item_input"
              />
            </div>
            <div class="table_item_box_l_r">
              <div class="fill_in_title">批次号</div>

              <input
                v-model="screen.batchname"
                type="text"
                placeholder="请输入批次号"
                class="table_item_input"
              />
            </div>
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">国内单号</div>

              <input
                v-model="screen.domesticnumber"
                type="text"
                placeholder="请输入国内单号"
                class="table_item_input"
              />
            </div>
            <div class="table_item_box_l_r">
              <div class="fill_in_title">收件人</div>

              <input
                v-model="screen.recipientname"
                type="text"
                placeholder="请输入收件人"
                class="table_item_input"
              />
            </div>
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">国际段运单号</div>

              <input
                v-model="screen.secondtracknumber"
                type="text"
                placeholder="请输入国际段运单号"
                class="table_item_input"
              />
            </div>
            <div class="table_item_box_l_r">
              <div class="fill_in_title">选择线路</div>
              <el-select
                clearable
                class="table_item_input"
                v-model="screen.routeid"
                placeholder="请选择选择线路"
              >
                <el-option
                  v-for="(item, index) in circuitData"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">选择线路</div>
              <el-select
                class="input_select"
                v-model="screen.routeid"
                placeholder="请选择国内快递公司"
              >
                <el-option
                  v-for="item in circuitData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div> -->
          <div class="table_item_box_s" style="flex-direction: column-reverse">
            <div class="table_item_box_l_r"></div>
            <div class="table_item_box_l_s">
              <el-button type="primary" @click="search" round>搜索</el-button>
              <el-button @click="reset" round>重置</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">未匹配包裹列表</div>
      </div>
      <div class="table_box">
        <el-table
         v-loading='tableLoading'
          :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
          :data="orderData.content"
          stripe
          style="width: 100%"
        >
          <el-table-column align="center" prop="datecreated" label="创建日期">
          </el-table-column>
          <el-table-column align="center" prop="ordernumber" label="单号">
          </el-table-column>
          <!-- <el-table-column
            align="center"
            prop="domesticnumber"
            label="国内单号"
          >
           <template slot-scope="scope">
             <input type="password" v-model="scope.row.domesticnumber">
            </template>
          </el-table-column> -->
          <el-table-column
            prop="domesticnumber"
            label="国内单号"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.domesticnumber
                ? scope.row.domesticnumber.replace(
                    /^(.{4}).*(.{3})$/,
                    "$1***$2"
                  )
                : ""
            }}</template>
          </el-table-column>
        <el-table-column align="center" prop="route" label="线路">
          </el-table-column>
          <!-- <el-table-column align="center" prop="recipientname" label="收件人">
          </el-table-column> -->
          <!-- <el-table-column align="center" prop="weightkg" label="收费重量">
          </el-table-column>
          <el-table-column align="center" prop="shippingcost" label="总运费">
          </el-table-column> -->
          <el-table-column align="center" prop="" label="包裹状态">
            <template slot-scope="scope">
              <div>未匹配</div>
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                class="round_btn"
                @click="showDialog(scope.row)"
                type="primary"
                size="small "
                round
                >填写包裹信息</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="paging_box">
          <el-pagination
            @current-change="pageChange"
            background
            layout="prev, pager, next"
            :total="orderData.totalElements"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :center="true"
      title="请输入国内运单号"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <!-- <el-divider></el-divider> -->
      <div class="numbers_info">
        <div class="">国内快递单号：{{ domesticnumberData }}</div>
      </div>

      <div class="fill_in_list">
        <div class="fill_in_list_l">
          <div class="fill_in_title">国内快递单号</div>
          <div class="fill_in_title_l">*</div>
        </div>
        <input
          v-model="domesticnumber"
          type="text"
          class="input_select"
          placeholder="请输入国内快递单号"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" class="confirm_btn" @click="toSelectRoute"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
// import houseImg from '@/assets/img/house.png'
export default {
  data() {
    return {
      tableLoading:'',
      // houseImg:houseImg,
      orderId: "",
      domesticnumber: "",
      domesticnumberData: "",
      domesticnumberDatas: "",
      circuitData: [],
      house: "",
      warehouseList: [],
      dialogVisible: false,
      orderData: [],
      routeid: "",
      screen: {
        page: 1,
        size: 10,
        state: "0",
        batchname: "",
        secondtracknumber: "",
        ordernumber: "",
        domesticnumber: "",
        routeid: "",
        recipientname: "",
        warehouseid: "",
      },
      warehouseid: "",
    };
  },
  created() {
    this.warehouse();
    this.circuit();
  },
  methods: {
    //点击仓库筛选
    clickHouse(e) {
      this.warehouseid = e;
      this.house = e;
      this.screen.warehouseid = e;
      this.orderList();
    },
    //仓库
    warehouse() {
      var data = {
        state: 0,
      };
      crudDept.getWarehousesNumber(data).then((res) => {
        this.warehouseList = res.content;
        this.screen.warehouseid = res.content[0].id;
        this.house = res.content[0].id;
        this.orderList();
      });
    },
    //分页
    pageChange(e) {
      this.screen.page = e;
      this.orderList();
    },
    selectRouteid(item) {
      this.$forceUpdate();
    },
    //筛查
    search() {
      this.orderList();
    },
    reset() {
      this.screen = {
        page: 1,
        size: 10,
        state: "0",
        batchname: "",
        secondtracknumber: "",
        ordernumber: "",
        domesticnumber: "",
        routeid: "",
        recipientname: "",
        warehouseid: this.warehouseid,
      };
      this.orderList();
    },
    //订单列表
    orderList() {
      this.tableLoading=true;
      crudDept.selectOrderWareAll(this.screen).then((res) => {
        this.orderData = res;
         this.tableLoading=false;
      }).catch((res)=>{
         this.tableLoading=false;
      })
    },
    // 线路
    circuit() {
      var data = {
        page: 1,
        size: 100,
      };
      crudDept.circuit(data).then((res) => {
        this.circuitData = res.content;
      });
    },
    toSelectRoute() {
      if (this.domesticnumberDatas != this.domesticnumber) {
        this.$message.error("快递单号不匹配，请重新输入");
        return false;
      }
      this.dialogVisible = false;
      localStorage.setItem("domesticnumber", this.domesticnumber);
      var house = this.house;
      var orderId = this.orderId;
      var routeid = this.routeid;
      this.$router.push({
        path:
          "/undetermined/selectRoute?house=" +
          house +
          "&id=" +
          orderId +
          "&routeid=" +
          routeid,
      });
    },
    showDialog(item) {
      if (item.isfromchina == 0) {
              var house = this.house;
      var orderId = item.id;
      var routeid = item.routeid;
        this.$router.push({
          path:
            "/undetermined/selectRoute?house=" +
            house +
            "&id=" +
            orderId +
            "&routeid=" +
            routeid,
        });
      } else {
        this.routeid = item.routeid;
        this.orderId = item.id;
        this.domesticnumberDatas = item.domesticnumber;
        this.domesticnumberData = item.domesticnumber
          ? item.domesticnumber.replace(/^(.{4}).*(.{3})$/, "$1***$2")
          : "";
        this.dialogVisible = true;
      }
    },
    productInformation() {
      this.$router.push({ name: "information" });
    },
    handleClose(done) {
      this.dialogVisible = false;
    },
  },
};
</script>
<style scoped>
.title_transportation_box >>> .el-badge__content {
  background-color: #ff6003 !important;
}
.title_transportation_box >>> .el-badge__content.is-fixed {
  top: 0 !important;
  right: 0px !important;
}
.el-badge {
  width: 62px;
  height: 62px;
  display: block;
  margin: 0 auto 10px;
}
.center_box >>> .dialog {
  border-radius: 20px !important;
}
.confirm_btn {
  margin: 0 auto !important;
  background-color: #5178ff;
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  border-radius: 22px;
}
input::-webkit-input-placeholder {
  color: #999999;
}
input::-moz-input-placeholder {
  color: #999999;
}
input::-ms-input-placeholder {
  color: #999999;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  /* width: 27%; */
  border-bottom: 1px solid #dedede;
  /* padding-bottom: 10px; */
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-right: 22px;
}
.fill_in_list_l {
  display: flex;
  align-items: baseline;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #ff0e0e;
}
.numbers_info {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-bottom: 22px;
}
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: auto !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  /*height:600px;*/
  max-height: calc(100% - 30px) !important;
  max-width: calc(100% - 30px) !important;
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
.table_box {
  margin-top: 32px;
}
.el-table td,
.el-table th {
  text-align: center !important;
}
.text_li {
  color: #ffa401 !important;
}
.el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}
.table_item_box_s {
  display: flex;
}
.table_item_box_l_s {
  display: flex;
}
.table_item_input >>> .el-input__inner {
  background: none !important;
  outline: none !important;

  border: none;
  /* color: #fff !important; */
  padding: 0;
}
.content_box_title {
  display: flex;
  align-items: center;
}
.circle_l {
  width: 18px;
  height: 18px;
  background: #5178ff;
  border-radius: 50%;
}
.circle_r {
  width: 18px;
  height: 18px;
  background: rgba(81, 120, 255, 0.27);
  border-radius: 50%;
  margin-left: -7px;
}
.text_xl {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  margin-left: 20px;
  color: #333333;
}
.content_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 38px 58px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.table_item_box {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 25px 0 0;
  box-sizing: border-box;
}
.table_item_box_l {
  margin-right: 30px;
  text-align: left;
}
.table_item_box_l_r {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #ffffff;

  border: 1px solid #dedede;
  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select {
  width: 100%;
  height: 40px;
  background: #ffffff;

  border: none;
  opacity: 1;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select >>> .el-input__inner {
  border: none !important;
  padding: 0 !important;
  width: 100% !important;
}
.input_select_table {
  padding: 0 !important;
  width: 180px;
  height: 40px;

  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #ff0e0e;
}
.title_transportation {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.title_transportation_box {
  margin-right: 90px;
  cursor: pointer;
}
.title_transportation_box:hover .transportation_img {
  box-shadow: 0 5px 18px 0 rgba(0, 0, 0, 0.2);
}

.transportation_img {
  width: 56px;
  height: 56px;
  background: #ffffff;
  /* border: 1px solid #6666; */
  border-radius: 50%;
  margin: 0 auto;
  display: block;
  object-fit: cover;
}
.transportation_text {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;

  text-align: center;
  margin-top: 5px;
  width: 100%;
}
.box_shadow {
  width: 60px !important;
  height: 60px !important;
  box-shadow: 0 5px 18px 0 rgba(0, 0, 0, 0.5);
}
.color2 {
  color: #5178ff;
}
</style>


// WEBPACK FOOTER //
// src/views/undetermined/unmatch.vue